import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["href", "className", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import qs from 'query-string';
import Router, { useRouter } from 'next/router';
import NextLink from 'next/link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Link = function Link(props) {
  var href = props.href,
      className = props.className,
      children = props.children,
      linkProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx(NextLink, _objectSpread(_objectSpread({
    href: href
  }, linkProps), {}, {
    children: children
  }));
};
export function withRouter(C) {
  return function (props) {
    var router = useRouter();
    var info = {
      match: {
        params: router.query
      },
      location: {
        pathname: (router.asPath || '').split('?')[0],
        search: qs.stringify(router.query)
      },
      history: {
        push: router.push,
        replace: function replace(url) {
          if (url.startsWith('#')) {
            if (true) {
              window.location.hash = url;
            }
          } else {
            router.replace(url);
          }
        }
      }
    };
    return /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, props), info));
  };
}
export var Route = function Route(props) {
  var router = useRouter();
  var exp = props.exact ? props.path : "".concat(props.path, "*");
  var re = new RegExp(exp.replace('*', '.*'));
  var matches = re.test(router.asPath);
  if (props.children) return props.children({
    match: matches ? {
      url: router.asPath
    } : null
  });

  if (matches) {
    if (props.render) return props.render();
  }

  return /*#__PURE__*/_jsx(_Fragment, {});
};
export var Redirect = function Redirect(props) {
  var router = useRouter();

  if (false) {
    return null;
  }

  if (props.replace) {
    router.replace(props.to);
  } else {
    router.push(props.to);
  }

  return null;
};
export function isomorphicRedirect(res, href) {
  var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (res) {
    res.writeHead(302, {
      Location: href
    });
    res.end();
  } else {
    if (replace) {
      Router.replace(href);
    } else {
      Router.push(href);
    }
  }
}